<!--update-game-modal-->
<div class="modal fade" id="updateGameModal" tabindex="-1" aria-labelledby="updateGameModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-dark text-white border-secondary">
            <div class="modal-header border-secondary">
                <h5 class="modal-title fw-bold" id="updateGameModalLabel">
                    <i class="bi bi-folder-fill text-warning me-2"></i>Game Installation Required
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body text-center py-4">
                <div class="mb-3">
                    <i class="bi bi-exclamation-triangle-fill text-warning display-4"></i>
                </div>
                <h5 class="fw-bold mb-2">{{ game()?.title || 'Game' }} is not configured</h5>
                <p class="text-secondary small mb-0 px-3">
                    This lobby requires {{ game()?.title || 'the game' }} to be installed on your computer. Please select your game installation folder to enable playing and launching matches.
                </p>
            </div>
            <div class="modal-footer border-secondary p-2 d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-secondary px-4 fw-bold" data-bs-dismiss="modal">Later</button>
                <button type="button" class="btn btn-warning px-4 text-dark fw-bold" (click)="browseGamePath()">
                    <i class="bi bi-folder2-open me-1"></i>Select Installation Folder
                </button>
            </div>
        </div>
    </div>
</div>
<!--./update-game-modal-->
